var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Actions, Effect, ofType } from "@ngrx/effects";
import { LoadEventsSuccess } from "./calendar.actions";
import { Store } from "@ngrx/store";
import { switchMap, map } from "rxjs/operators";
import { events, samples } from "@app/core/store/calendar/event.mocks";
import { of } from "rxjs";
import { AuthActionTypes } from "@app/core/store/auth";
var CalendarEffects = /** @class */ (function () {
    function CalendarEffects(actions$, store) {
        this.actions$ = actions$;
        this.store = store;
        this.effect$ = this.actions$.pipe(ofType(AuthActionTypes.AuthInit), switchMap(function (_) {
            return of({
                events: events,
                samples: samples
            });
        }), map(function (_) { return new LoadEventsSuccess(_); }));
    }
    __decorate([
        Effect(),
        __metadata("design:type", Object)
    ], CalendarEffects.prototype, "effect$", void 0);
    return CalendarEffects;
}());
export { CalendarEffects };
